var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsersRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 13.3334,
    r: 6.16667,
    stroke: "white",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93264 25.8303C9.89941 23.6006 12.2481 22.5 14.6783 22.5H25.3217C27.7519 22.5 30.1006 23.6006 31.0674 25.8303C31.7198 27.335 32.3234 29.2762 32.4675 31.5001C32.5032 32.0512 32.0523 32.5 31.5 32.5H8.5C7.94772 32.5 7.49676 32.0512 7.53248 31.5001C7.67664 29.2762 8.28023 27.335 8.93264 25.8303Z",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsersRoute);
export default __webpack_public_path__ + "static/media/icon-users-route.52c1fde706948bb54d00ef2959c1ffef.svg";
export { ForwardRef as ReactComponent };